import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import { IoIosMan } from "react-icons/io";
import { FaChildren } from "react-icons/fa6";
import { IoIosWoman } from "react-icons/io";
import styled from "./styled.module.css";
import CustomSelect from "../../component/custom-select";
import { getAllCity, getUsersCountAPI } from "../../api/auth";
import BarChart from "./chart/BarChart";
// import BarChartSection from "./chart";

function Dashbaord() {
  const [users, setUsers] = useState([]);
  const [city, setCity] = useState([]);

  const handleUsers = async () => {
    const res = await getUsersCountAPI();
    if (res.remote === "success") {
      const { totalUsers, totalMen, totalWomen, totalChildren } = res.data;
      const userData = [
        {
          id: 0,
          number: totalUsers,
          user: "Total users",
          icon: <PersonIcon />,
        },
        {
          id: 1,
          number: totalMen,
          user: "Total men",
          icon: <IoIosMan />,
        },
        {
          id: 2,
          number: totalChildren,
          user: "Total children",
          icon: <FaChildren />,
        },
        {
          id: 3,
          number: totalWomen,
          user: "Total women",
          icon: <IoIosWoman />,
        },
      ];
      setUsers(userData);
    } else {
      console.log("API Error:", res);
    }
  };


  useEffect(() => {
    handleUsers();
    getCity();
  }, []);

  const getCity = async () => {
    const resp = await getAllCity();
    if (resp.remote === "success") {
      setCity(resp || []);
    }
  };
  const City = [
    { value: "Gwalior", label: "Gwalior" },
    { value: "Bhopal", label: "Bhopal" },
    { value: "Bhind", label: "Bhind" },
    { value: "Noida", label: "Noida" },
  ];

  return (
    <div>
      <Box sx={{ margin: "10px 0" }}>
        <Typography
          variant="h4"
          sx={{ fontSize: "30px", fontWeight: "500", color: "#000" }}
        >
          Dashboard
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={5} className="CardGrid">
          {users.map((item, index) => (
            <Grid item lg={3} key={index}>
              <Box
                className={styled.cardBox}
                sx={{
                  backgroundColor:
                    index === 1
                      ? "#4462FF"
                      : index === 2
                        ? "#0EE917"
                        : index === 3
                          ? "#FF2DDD"
                          : "defaultColor", // Add more conditions if needed
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Box sx={{ width: "175px", paddingLeft: "15px" }}>
                    <Typography variant="h5">{item.number}</Typography>
                    <Typography variant="h6">{item.user}</Typography>
                  </Box>
                  <Box className={styled.iconBox}>{item.icon}</Box>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/*chart*/}
      <Stack direction="row" alignItems="center" spacing={3} mt={5}>
        <Typography variant="h5">Total users in cities</Typography>
        <CustomSelect name="city" options={City} />
      </Stack>
      <input type="date" id="birthday" name="birthday" />
      {/*chart*/}
      <Stack style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100hv",
        margin:"10px",
      }}>
        <BarChart />
      </Stack>
    </div>
  );
}

export default Dashbaord;
